<template>
  <div class="page-products">
    <div class="container">
      <div class="products-header">
        <h2 class="section-title">产品中心</h2>
        <p class="section-desc">PRODUCTS CENTER · 手钣样品 · 不锈钢 / 铜材 / 铝材 / 定制加工</p>
      </div>

      <p class="loading" v-if="loading">加载中...</p>
      <p class="error-msg" v-else-if="error">{{ error }}</p>
      <div v-else class="products-wrap">
        <!-- 品类筛选 -->
        <div class="filter-bar">
          <button
            v-for="c in catList"
            :key="c.name"
            :class="['filter-btn', { on: active === c.name }]"
            @click="active = c.name"
          >
            {{ c.name }}<em>{{ c.count }}</em>
          </button>
        </div>

        <!-- 大图产品网格 -->
        <div class="product-grid">
          <div
            class="product-card"
            v-for="p in filtered"
            :key="p.id"
            @click="openPreview(p)"
          >
            <div class="product-image">
              <img class="product-img" :src="p.imageUrl" :alt="p.name" loading="lazy" />
              <span class="image-zoom-hint">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35M11 8v6M8 11h6" />
                </svg>
              </span>
            </div>
            <div class="product-info">
              <span class="product-category">{{ p.category }}</span>
              <h3 class="product-name">{{ p.name }}</h3>
              <p class="product-material" v-if="p.material">材质：{{ p.material }}</p>
              <p class="product-spec" v-if="p.specification">规格：{{ p.specification }}</p>
            </div>
          </div>
          <div class="empty-state" v-if="!filtered.length">
            <p>该品类暂无产品</p>
            <router-link to="/contact" class="btn btn-primary">联系我们定制</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 大图预览 -->
    <div class="image-preview-overlay" v-if="preview" @click.self="preview = null">
      <div class="image-preview-container">
        <button class="preview-close" @click="preview = null">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
        <div class="preview-image-wrapper">
          <img class="preview-image" :src="preview.imageUrl" :alt="preview.name" />
        </div>
        <div class="preview-info">
          <h3 class="preview-name">{{ preview.name }}</h3>
          <span class="preview-category">{{ preview.category }}</span>
          <p class="preview-detail" v-if="preview.material">材质：{{ preview.material }}</p>
          <p class="preview-detail" v-if="preview.specification">规格：{{ preview.specification }}</p>
          <p class="preview-desc" v-if="preview.description">{{ preview.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProducts } from '../api/portal'

export default {
  name: 'Products',
  data() {
    return {
      products: [],
      active: '全部',
      loading: true,
      error: '',
      preview: null
    }
  },
  computed: {
    catList() {
      const order = ['全部', '不锈钢样品', '铜材样品', '铝材样品', '定制样品']
      const counts = {}
      this.products.forEach(p => { counts[p.category] = (counts[p.category] || 0) + 1 })
      const list = order
        .filter(n => n === '全部' || counts[n])
        .map(n => ({ name: n, count: n === '全部' ? this.products.length : counts[n] }))
      // 兜底：接口里出现未知品类也展示
      Object.keys(counts).forEach(n => {
        if (!order.includes(n)) list.push({ name: n, count: counts[n] })
      })
      return list
    },
    filtered() {
      if (this.active === '全部') return this.products
      return this.products.filter(p => p.category === this.active)
    }
  },
  async created() {
    try {
      const res = await getProducts()
      if (res.data && res.data.success) {
        this.products = res.data.data || []
      } else {
        this.error = (res.data && res.data.message) || '产品加载失败'
      }
    } catch (e) {
      this.error = '网络请求失败，请稍后重试'
    } finally {
      this.loading = false
    }
  },
  methods: {
    openPreview(p) {
      this.preview = p
      document.body.style.overflow = 'hidden'
    }
  },
  watch: {
    preview(v) {
      if (!v) document.body.style.overflow = ''
    }
  }
}
</script>
